import React from 'react';
import PropTypes from 'prop-types';
import { Caption } from '@xo-union/tk-ui-typography';
import { observer, inject } from 'mobx-react';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import OverviewRsvpDropdownContents from '~/glm/components/guest-list/header/overview-rsvp-dropdown-contents.jsx';
import EventCollection from '~/glm/models/gds/event-collection';
import styles from './overview-rsvp-filter-dropdown.scss';
import SelectDropdown from './select-dropdown';
import MissingInfoDropdown from '../cells/missing-info-dropdown';

@inject('gdsUiState')
@observer
class OverviewRsvpFilterDropdown extends React.Component {
  static propTypes = {
    rsvpFilterFunc: PropTypes.func,
    events: PropTypes.instanceOf(EventCollection),
    gdsUiState: PropTypes.instanceOf(GdsUiState),
    label: PropTypes.string,
  };

  state = {
    selectedRsvpFilter: null,
    menuOpen: false,
  };

  setMenuState = bool => {
    if (typeof bool === 'boolean') {
      this.setState({ menuOpen: bool });
    } else {
      this.setState(state => ({
        menuOpen: !state.menuOpen,
      }));
    }
  };

  render() {
    const { rsvpFilterFunc, events, gdsUiState, label } = this.props;

    return (
      <SelectDropdown setMenuState={this.setMenuState} label={label} {...this.state}>
        <div className={styles.contentContainer}>
          <OverviewRsvpDropdownContents
            type="filter"
            rsvpFilter={rsvpFilterFunc}
            events={events}
            gdsUiState={gdsUiState}
          />
          <Caption className={styles.sectionHeader}>Missing Info</Caption>
          <MissingInfoDropdown
            showCheckmark
            addressFilter={gdsUiState.addressFilter}
            gdsUiState={gdsUiState}
            border={false}
          />
        </div>
      </SelectDropdown>
    );
  }
}

export default OverviewRsvpFilterDropdown;
